var $b6d50b1d20768ce4$exports = {};
$b6d50b1d20768ce4$exports = {
  "removeButtonLabel": "Eliminar",
  "removeDescription": "Prima Delete para eliminar a tag."
};
export { $b6d50b1d20768ce4$exports as default };